<template>
  <div>
    <h1>Clonar formulário</h1>
    <success-fade-alert ref="alert" msg="Formulário criado com sucesso" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <div>
      <h3>Empresa origem</h3>      
      <b-table
        class="table-nowrap"
        hover
        ref="selectTable"
        :busy.sync="isBusy"
        :items="loadDataCompany"
        :fields="fildesCompanyTable"
        selectable
        :select-mode="selectModeCodigo"
        @row-selected="onRowSelectedCodigo"
        :filter="companyFrom"
        :filter-debounce="500"
        :per-page="tablePerPageCompanyFrom"
        :current-page="tableCurrentPageCompanyFrom">
      <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.filterKey">
              <div v-if="companyFrom[field.filterKey] != null">
                <b-form-input
                  v-model="companyFrom[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
      </template>      
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>        
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPageCompanyFrom"
        :pageOptions.sync="tablePageOptionsCompanyFrom"
        :perPage.sync="tablePerPageCompanyFrom"
        :rowCount.sync="tableRowCountCompanyFrom"
      >
      </table-pagination-props>
    </div>
    <div v-if="companyId > 0">
      <h3>Empresa destino</h3>
      <b-table
        class="table-nowrap"
        hover
        :busy.sync="isBusy"
        :items="loadDataCompanyTo"
        :fields="fildesCompanyTable"
        selectable
        :filter="companyTo"
        :select-mode="selectModeCodigo"
        :filter-debounce="500"
        :per-page="tablePerPageCompanyTo"
        :current-page="tableCurrentPageCompanyTo"
        @row-selected="onRowSelectedCompanyTo"
      >
      <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.filterKey">
              <div v-if="companyTo[field.filterKey] != null">
                <b-form-input
                  v-model="companyTo[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
      </template>   
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPageCompanyTo"
        :pageOptions.sync="tablePageOptionsCompanyTo"
        :perPage.sync="tablePerPageCompanyTo"
        :rowCount.sync="tableRowCountCompanyTo"
      >
      </table-pagination-props>
    </div>
    <div v-if="companyId > 0 && companyToId >0">
      <h3>Formulário a ser clonado</h3>
      <b-table
        class="table-nowrap"
        hover
        :items="loadDataForm"
        :fields="fieldsForm"
        :busy.sync="isBusy"
        selectable
        :select-mode="selectModeCodigo"
        :filter="companyForm"
        :filter-debounce="500"
        :per-page="tablePerPageForm"
        :current-page="tableCurrentPageForm"
        @row-selected="onRowSelectedForm"
      >
      <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.filterKey">
              <div v-if="companyForm[field.key] != null">
                <b-form-input
                  v-model="companyForm[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
      </template>   
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPageForm"
        :pageOptions.sync="tablePageOptionsForm"
        :perPage.sync="tablePerPageForm"
        :rowCount.sync="tableRowCountForm"
      >
      </table-pagination-props>
    </div>
    <div v-if="companyToId > 0 && formId > 0">
      <b-container class="mb-5">
        <h3>Confirmação da clonagem</h3>
        <b-row>
          <b-col>
            <h4>Empresa origem</h4>
            <base-row-detail
              label="Id"
              :value="`${this.companyFromDetails.id}`"
            ></base-row-detail>
            <base-row-detail
              label="Cnpj"
              :value="`${this.companyFromDetails.cnpj}`"
            ></base-row-detail>
            <base-row-detail
              label="Razão social"
              :value="`${this.companyFromDetails.razaoSocial}`"
            ></base-row-detail>
            <base-row-detail
              label="Nome fantasia"
              :value="`${this.companyFromDetails.nomeFantasia}`"
            ></base-row-detail>
          </b-col>
          <b-col cols="4">
            <h4>Empresa destino</h4>
            <base-row-detail
              label="Id"
              :value="`${this.companyToDetails.id}`"
            ></base-row-detail>
            <base-row-detail
              label="Cnpj"
              :value="`${this.companyToDetails.cnpj}`"
            ></base-row-detail>
            <base-row-detail
              label="Razão Social"
              :value="`${this.companyToDetails.razaoSocial}`"
            ></base-row-detail>
            <base-row-detail
              label="Nome fantasia"
              :value="`${this.companyToDetails.nomeFantasia}`"
            ></base-row-detail>
          </b-col>
          <b-col>
            <h4>Formulário</h4>
            <base-row-detail
              label="Id"
              :value="`${this.companyFormDetails.id}`"
            ></base-row-detail>
            <base-row-detail
              label="Nome"
              :value="`${this.companyFormDetails.nome}`"
            ></base-row-detail>
          </b-col>
        </b-row>
        <b-button v-on:click="cloningForm()">Clonar</b-button>
      </b-container>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
import BaseRowDetail from "../../base/BaseRowDetail.vue";
export default {
  name: "List",
  components: {
    TablePaginationProps,
    BaseRowDetail,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data: function () {
    return {
      alert: {
        error: "",
      },
      fildesCompanyTable: [
        {
          label: "Selecionado",
          key: "selected",
        },
        {
          label: "Id",
          key: "id",
          filterKey: "id",
          sortable: true,
        },
        {
          label: "numero Documento",
          key: "numeroDocumento",
          filterKey: "cnpj",
          sortable: true,
        },
        {
          label: "Razão social",
          key: "razaoSocial",
          filterKey: "razaoSocial",
          sortable: true,
        },
        {
          label: "Nome fantasia",
          key: "nomeFantasia",
          filterKey: "nomeFantasia",
          sortable: true,
        },
      ],
      fieldsForm: [
        {
          label: "Selecionado",
          key: "selected",
        },
        {
          label: "Id",
          key: "id",
          filterKey: "id",
          sortable: true,
        },
        {
          label: "Nome",
          key: "nome",
          filterKey: "formName",
          sortable: true,
        },
      ],
      companyFromDetails: {
        id: 0,
        cnpj: "",
        razaoSocial: "",
        nomeFantasia: "",
      },
      companyToDetails: {
        id: 0,
        cnpj: "",
        razaoSocial: "",
        nomeFantasia: "",
      },
      companyFormDetails: {
        nome: "",
        id: 0,
      },
      companyFrom: {
        id: "",
        cnpj: "",
        razaoSocial: "",
        nomeFantasia: "",
      },
      companyTo: {
        id: "",
        cnpj: "",
        razaoSocial: "",
        nomeFantasia: "",
      },      
      companyForm: {
        nome: "",
        id: "",
      },     
      isBusy: false,
      itemsCompanyTable: [],
      itemsCompanyTableTo: [],
      itemsCloningForm: [],
      tableRowCountCompanyFrom: 0,      
      tablePerPageCompanyFrom: 5,
      tablePageOptionsCompanyFrom: [5, 10, 25, 50, 100, 150],
      tableCurrentPageCompanyFrom: 1,
      tableRowCountCompanyTo: 0,
      tablePerPageCompanyTo: 5,
      tablePageOptionsCompanyTo: [5, 10, 25, 50, 100, 150],
      tableCurrentPageCompanyTo: 1,
      tableRowCountForm: 0,
      tablePerPageForm: 5,
      tablePageOptionsForm: [5, 10, 25, 50, 100, 150],
      tableCurrentPageForm: 1,
      selectModeCodigo: "single",
      selectedCompanyFrom: [],
      selectedCompanyTo: [],
      selectedForm: [],
      selected: false,
      companyId: 0,
      companyToId: 0,
      formId: 0,
    };
  },
  computed: {},
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async loadDataCompany(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        id: ctx.filter.id,
        numeroDocumento: ctx.filter.cnpj,
        razaoSocial: ctx.filter.razaoSocial,
        nomeFantasia: ctx.filter.nomeFantasia
      };
      this.$apiChecklist
        .post("/CloningForm/GetAllCompany", apiParam)
        .then((response) => {
          this.itemsCompanyTable = response.data.items;
          const items = response.data.items;
          this.tableRowCountCompanyFrom = response.data.totalItems;
          this.isBusy = false;
          callback(items);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error.response.data.errors);
          callback([])
          this.isBusy = false;
        });
    },
    async loadDataCompanyTo(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        id: ctx.filter.id,
        numeroDocumento: ctx.filter.cnpj,
        razaoSocial: ctx.filter.razaoSocial,
        nomeFantasia: ctx.filter.nomeFantasia
      };
      this.$apiChecklist
        .post("/CloningForm/GetAllCompany", apiParam)
        .then((response) => {
          this.itemsCompanyTableTo = response.data.items;
          const items = response.data.items;
          this.tableRowCountCompanyTo = response.data.totalItems;
          this.isBusy = false
          callback(items)
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error.response.data.errors);
          callback([])
          this.isBusy = false;
        });      
    },
    onRowSelectedCodigo(items) {
      this.companyId = 0;
      this.selectedCompanyFrom = items;
      if (items != null) this.selected = true;
      items.forEach(item => {
        this.companyId = item.id;
        this.companyFromDetails.id = item.id;
        this.companyFromDetails.cnpj = item.numeroDocumento;
        this.companyFromDetails.razaoSocial = item.razaoSocial;
        this.companyFromDetails.nomeFantasia = item.nomeFantasia;
      });
    },    
    onRowSelectedCompanyTo(items) {
      this.companyToId = 0;
      this.selectedCompanyTo = items;
      items.forEach(item => {
        this.companyToId = item.id;
        this.companyToDetails.id = item.id;
        this.companyToDetails.cnpj = item.numeroDocumento;
        this.companyToDetails.razaoSocial = item.razaoSocial;
        this.companyToDetails.nomeFantasia = item.nomeFantasia;
      });
    },
    onRowSelectedForm(items) {
      this.selectedForm = items;
      items.forEach(item => {
        this.formId = item.id;
        this.companyFormDetails.id = item.id;
        this.companyFormDetails.nome = item.nome;
      });
    },
    async loadDataForm(ctx, callback) {
      this.isBusy = true;
      let id = this.companyId;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        id: ctx.filter.id,
        nome: ctx.filter.nome
      };
      this.$apiChecklist
        .post("/CloningForm/GetAllForm/" + id, apiParam)
        .then((response) => {
          this.itemsCloningForm = response.data.items;
          const items = this.itemsCloningForm;
          this.tableRowCountForm = response.data.totalItems;
          this.isBusy = false;
          callback(items);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error.response.data.errors);
          callback([])
          this.isBusy = false
        });
    },
    cloningForm() {      
      let idForm = this.formId;
      let idTo = this.companyToId;
      let idFrom = this.companyId;
      this.$apiChecklist
        .post(
          "/CloningForm/create/" +
            idForm.toString() +
            "/" +
            idFrom.toString() +
            "/" +
            idTo.toString()
        )
        .then((response) => {
          this.isBusy = false;   
          if(response.data.success == false)
            this.$refs.fadeAlertDanger.show();
          else
            this.$refs.alert.show();
          this.resetModal();
          this.clearSelect();
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error.response.data.errors);
          this.$refs.fadeAlertDanger.show();
        });
    },
    clearSelect(){      
      this.$refs.selectTable.clearSelected()
    },
    resetModal() {
      //campos
      this.formId = 0;
      this.companyFormDetails.id = 0;
      this.companyFormDetails.nome = "";
      this.companyToId = 0;
      this.companyToDetails.id = 0;
      this.companyToDetails.nomeFantasia = "";
      this.companyToDetails.cnpj = "";
      this.companyToDetails.razaoSocial = "";
      this.companyId = 0;
      this.companyFromDetails.id = 0;
      this.companyFromDetails.nomeFantasia = "";
      this.companyFromDetails.cnpj = "";
      this.companyFromDetails.razaoSocial = "";
      //filters
      this.companyForm.id = "";
      this.companyForm.nome = "";
      this.companyTo.id = "";
      this.companyTo.nomeFantasia = "";
      this.companyTo.cnpj = "";
      this.companyTo.razaoSocial = "";
      this.companyFrom.id = "";
      this.companyFrom.nomeFantasia = "";
      this.companyFrom.cnpj = "";
      this.companyFrom.razaoSocial = "";
    },    
  },
  
};
</script>

<style scoped>
.table-nowrap{
  color: white !important;
}
</style>
